import { render, staticRenderFns } from "./NewsRecommendItem.vue?vue&type=template&id=cddcdc96&scoped=true"
import script from "./NewsRecommendItem.vue?vue&type=script&lang=js"
export * from "./NewsRecommendItem.vue?vue&type=script&lang=js"
import style0 from "./NewsRecommendItem.vue?vue&type=style&index=0&id=cddcdc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddcdc96",
  null
  
)

export default component.exports